import React, { useState } from 'react';

import { ActivityWidget } from '../ActivityWidget';
import { Icon } from '../../../../../base/components/Icon';
import { Button } from '../../../../../base/components/Button';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { UpgradeModal } from '../UpgradeModal';
import { vacancyActions } from '../../redux/slices/vacancySlice';

import './styles.scss';
import { Link, useLocation } from 'react-router-dom';
import { CloseVacancyModal } from '../CloseVacancyModal';

export const VacancySidebar = () => {
    const vacancy = useAppSelector((state) => state.vacancy);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [showUpgradeVacancyModal, setShowUpgradeVacancyModal] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);

    const toggleCloseModalVisibility = () => setShowCloseModal(!showCloseModal);

    if (!vacancy || !vacancy.vacancyData) {
        return null;
    }

    const {
        employer,
        recommendations,
        responses,
        vacancyData: { id, isActive },
    } = vacancy;

    const publishVacancyHandler = () => {
        dispatch(vacancyActions.openVacancyRequest(id));
    };

    const updateVacancyHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        dispatch(vacancyActions.renewVacancyRequest(id));
    };

    return (
        <div className='vacancy-sidebar'>
            <div className='vacancy-sidebar__company-logo'>
                <img src={employer?.logo} alt='Logo' />
            </div>
            <div className='vacancy-sidebar__company-name'>
                {employer?.name}
                <Icon
                    icon='badge-check-solid'
                    size='16px'
                    color='highlight'
                    className='vacancy-sidebar__verified-icon'
                />
            </div>
            <a href='/employer/update?update=company' className='vacancy-sidebar__link'>
                {__t('Редактировать описание')}
            </a>
            <div className='vacancy-sidebar__company-additional-info'>
                <Icon icon='circle-check-light' size='20px' className='vacancy-sidebar__company-additional-info-icon' />
                {__t('NIP')}: {employer?.nip}
            </div>

            <div className='vacancy-sidebar__divider'></div>

            <p className='vacancy-sidebar__title'>{__t('Управление вакансией')}</p>

            {responses && (
                <ActivityWidget vacancyId={id} responses={responses} className='vacancy-sidebar__activity-widget' />
            )}

            <div className='vacancy-sidebar__buttons'>
                {recommendations && recommendations.workers && (
                    <a href={recommendations.workers.url} className='interaction-button'>
                        <Icon
                            icon='user-helmet-safety-light'
                            size='20px'
                            color='highlight'
                            className='interaction-button__icon'
                        />
                        {__t('Кандидаты')}
                        &nbsp;{recommendations.workers.count}&nbsp;
                        {__t('CV')}
                        <Icon
                            icon='chevron-right-light'
                            size='20px'
                            color='highlight'
                            className='interaction-button__arrow'
                        />
                    </a>
                )}

                <div className='vacancy-sidebar__divider'></div>

                <Link to={`/vacancy/update/${id}`} className='interaction-button' state={{ from: location }}>
                    <Icon icon='pencil-light' size='20px' color='highlight' className='interaction-button__icon' />
                    {__t('Редактировать ')}
                    <Icon
                        icon='chevron-right-light'
                        size='20px'
                        color='highlight'
                        className='interaction-button__arrow'
                    />
                </Link>

                <div className='vacancy-sidebar__divider'></div>

                <Link to={`/vacancy/duplicate/${id}`} className='interaction-button' state={{ from: location }}>
                    <Icon icon='copy-light' size='20px' color='highlight' className='interaction-button__icon' />
                    {__t('Дублировать')}
                    <Icon
                        icon='chevron-right-light'
                        size='20px'
                        color='highlight'
                        className='interaction-button__arrow'
                    />
                </Link>

                <div className='vacancy-sidebar__divider'></div>

                {isActive && (
                    <>
                        <a href='' className='interaction-button' onClick={updateVacancyHandler}>
                            <Icon
                                icon='arrow-rotate-right-light'
                                size='20px'
                                color='highlight'
                                className='interaction-button__icon'
                            />
                            {__t('Обновить вакансию')}
                            <Icon
                                icon='chevron-right-light'
                                size='20px'
                                color='highlight'
                                className='interaction-button__arrow'
                            />
                        </a>

                        <Button onClick={() => setShowUpgradeVacancyModal(true)} className='vacancy-sidebar__button'>
                            {__t('Продвигать')}
                        </Button>

                        <Button
                            onClick={toggleCloseModalVisibility}
                            className='vacancy-sidebar__button'
                            type='secondary'
                        >
                            {__t('Закрыть')}
                        </Button>
                    </>
                )}

                {!isActive && (
                    <Button onClick={publishVacancyHandler} className='vacancy-sidebar__button'>
                        {__t('Опубликовать')}
                    </Button>
                )}
            </div>

            <UpgradeModal
                vacancyId={id}
                visible={showUpgradeVacancyModal}
                closeModalHandler={() => setShowUpgradeVacancyModal(false)}
            />
            <CloseVacancyModal
                vacancyId={id}
                visible={showCloseModal}
                actionAfterSubmit='redirect'
                visibilityHandler={toggleCloseModalVisibility}
            />
        </div>
    );
};
